<template>
  <div class="container">
    <div class="container left">

      <div class="row" style="padding-left: 15px;">      
        <div class="col-sm-1">
          <div class="dropdown" style="position:fixed;left:0;top:0;padding:0;margin-top:0;margin-bottom:0">
            <ReportsMenu/>
          </div>          
        </div>
        <div class="col-sm-11" style="text-align:center">  
          <!--<div class="col-sm-2" style="text-align:right;color: white;padding-left: 100px;">
          <table>
            <tr>
              <td><label title="User" style="font-size:1.2em">User:</label></td>
              <td><input type="checkbox"  @click="handleAll()" id="select_all" style="font-size:1.5em"> </td>
            </tr>
          </table>
        </div>
        <div class="col-sm-2" style="text-align:left;font-size:1.3em;">
          <select id="paid_by" v-model="paid_by" name="paid_by"  style="color:black;font-size:1.3em">
            <option value="0">Select a user</option>
          </select>                  
        </div>-->
           <!--               
          <div class="col-sm-2" style="text-align:right">
            <div style="text-align:right;color:white">
              <label title="User" style="font-size:1.5em">User:</label>
            </div>
          </div>
          <div class="col-sm-2" style="text-align:left">
            <select  id="paid_by" v-model="paid_by" name="paid_by"  style="color:black;font-size:1.5em">
              <option value="0">Select a user</option>
            </select>                  
          </div>
          -->
          <div class="col-sm-2" style="text-align:right">
            <div style="text-align:right;color:white">
                <label title="Date" style="font-size:1.5em">Date:</label>
            </div>
          </div>
          <div style="text-align:left">
        <!--<input type="text" v-model="daydate" v-on:keyup.enter="findDailyTotal()" class="form-control" style="font-size:1.5em">-->
            <datepicker class="col-sm-2" v-model="state.date" 
              name="selected_date"
              format="yyyy-MM-dd"
              style = "width: max-content"
              @selected="parentfunctionSelectedhandler" 
              @opened="datepickerOpenedFunction" 
              @closed="parentfunctionCloseHandler">
            </datepicker>
          </div>
          <!--          <div class="col-sm-2" style="text-align:right;color: white;padding-left: 100px;">
          <table>
            <tr>
              <td><label title="ToDate" style="font-size:1.2em">To Date:</label></td>
              <td><input type="checkbox"  @click="handleToDate()" style="font-size:1.5em"> </td>
            </tr>
          </table>
        </div>
        -->

        <div style="text-align:left">
          <datepicker class="col-sm-2" v-model="stateTo.dateTo" id="select_todate"
              name="selected_date_to"
              format="yyyy-MM-dd"
              style = "width: max-content"
              @selected="parentfunctionSelectedhandler" 
              @opened="datepickerOpenedFunction" 
              @closed="parentfunctionCloseHandler">
            </datepicker>
          </div>
          <div class="col-sm-2" style="text-align:left">
              <div style="text-align:left">
                <!--<input type="text" v-model="orderDate" v-on:keyup.enter="findItemsDaily()" class="form-control" style="font-size:1.5em">-->
                <button class="btn btn-success" style="font-size:1.5em; scale: 1.12;margin-top: 3px;margin-right: 50%;margin-left: -10%" @click="handleFindItemsDaily()">Find</button>  
              </div>
          </div>

        </div>       </div>    

 
      <div v-if="toggle">
        <br>
        <!--
        <button v-if="!showChart" class="btn btn-success" style="font-size:1.5em" @click="showChartHandling()">Show Chart</button>  
        <button v-if="showChart" class="btn btn-success" style="font-size:1.5em" @click="showChartHandling()">Hide Chart</button>  
        -->
        <div style="background-color: #fff;" v-if="showChart">
          <BarChart :chartData="chartData"/>        
      </div>
      <div class="row table-wrap" style="color: #fff; padding: 0 0 0 25%;">
      </div>
        

        <div v-if="showChart" class="row table-wrap" style="color: #fff; ">
          <div style="text-align:right">
            <button class="btn btn-success" style="font-size:1.5em" @click="printReportChart('bar-chart')">Print</button>  
            <!--
            <input type="text" class="form-control" v-model="chartHeight"/>
            <button class="btn btn-success" style="font-size:1.5em" @click="rebuildChart(rebuildChart)">Refresh Chart</button>  
            -->
        </div>

        <table class="table"  style="color: #fff;">
          <thead>
            <tr>
              <th  style="font-size:1.5em;text-align: right;">Item Name</th>
              <th  style="font-size:1.5em;text-align: right;">Items Count</th>
              <th  style="font-size:1.5em;text-align: right;">Quantity</th>
              <th  style="font-size:1.5em;text-align: right;">Return</th>
              <th  style="font-size:1.5em;text-align: right;">Price</th>
              <th  style="font-size:1.5em;text-align: right;">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in itemsDaily" :key="item.itemCode">
              <td style="font-size:1.5em;text-align: right;">{{item.itemCode}}</td>
              <td style="font-size:1.5em;text-align: right;">{{item.count_item}}</td>
              <td style="font-size:1.5em;text-align: right;">{{parseFloat(item.total_qty).toFixed(3)}}</td>
              <td style="font-size:1.5em;text-align: right;">{{parseFloat(item.total_qty_return).toFixed(3)}}</td>
              <td style="font-size:1.5em;text-align: right;">{{formatNumber(item.total_price/item.total_qty)}}</td>
              <td style="font-size:1.5em;text-align: right;">{{formatNumber(parseFloat(item.total_price).toFixed(2))}}</td>
            </tr>
            
            <tr>
              <td style="font-size:1.5em;text-align: right;background-color: black; font-weight: bold;">Totals</td>
              <td style="font-size:1.5em;text-align: right;background-color: black;">{{formatNumber(parseFloat(totalCount_).toFixed(0))}}</td>
              <td style="font-size:1.5em;text-align: right;background-color: black;"></td>
              <td style="font-size:1.5em;text-align: right;background-color: black;"></td>
              <td style="font-size:1.5em;text-align: right;background-color: black;"></td>
              <td style="font-size:1.5em;text-align: right;background-color: black;">{{formatNumber(parseFloat(totalTotal_).toFixed(2))}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>

    </div>
  </div>
</template>

<script>
  import numericpad from "@/components/SimpleKeyboard";
  import { useRoute } from 'vue-router'
  import { ref } from "vue"
  import axios from "axios";
  import router from '@/router';
  import commonServices from "@/shared/commonServices"
  // import ReportsMenu from "@/components/ReportsMenu";
  import AppHeader from "@/components/AppHeader";
  import BarChart from '@/components/BarChart'
  import Datepicker from 'vuejs3-datepicker';
  import 'vue-date-pick/dist/vueDatePick.css';
  import { ModelSelect } from 'vue-search-select'

export default {
    mixins: [commonServices],
    mounted() {
      //this.$el.querySelector('#paid_by').disabled = true;

      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth();
      let day = nowDate.getDate();
      this.state.date = new Date(year+'', month+'',  day+'');
      this.stateTo.dateTo = new Date(year+'', month+'',  day+'');
      this.orderDate = this.state.date;


      //this.getUsers();

      this.getCurrentDateTime();
      if(localStorage.appId===undefined && localStorage.appId===null){
        this.$router.push({ name: 'login'});
      }
      if(localStorage.reports_ok === "1"){
        this.reports_ok = true;
      }

      this.language = 'ar';
      this.handleLanguage();
      this.getLogo();
      this.logoImage = '<img src="'+this.logoUrl+'" width="70" height="50" alt="Logo">';
    },    
    components:{ BarChart, Datepicker, ModelSelect, AppHeader },
    data: function(){
        return {
          state: {date: new Date(2016, 9,  16)},
          stateTo: {dateTo: new Date(2016, 9,  16)},
          chartHeight: 400,
          chartData: {"labels":[], "datasets": []},
          reports_ok: false,
          users: [],
          usersJson: {},
          dataItems : [],
          showError: false,
          showChart: false,
          logoImage: '',
          itemsDaily: [],
          mainErrorMsg: '',
          logoUrl:'',
          jsonData: {},
          itemsDailyJson: {},
          language: 'en',
          languageName: '',
          toggle: true,
          orderDate:'',
          paid_by:0,
          select_all: false,
          select_todate: false,
          totalCount_: 0,
          totalQuantity_: 0,
          totalReturn_: 0,
          totalPrice_: 0,
          totalTotal_: 0,
          deptWiseReportDate: '',

        }
    },
    methods:{
      handleAll(){
        this.itemsDaily = [];
        this.chartData.datasets = [];

      if(this.select_all){
        this.select_all = false;
        this.$el.querySelector('#paid_by').disabled = true;
      }else{
        this.select_all = true;
        this.$el.querySelector('#paid_by').disabled = false;
      }
    },
    handleToDate(){
        this.itemsDaily = [];
        this.chartData.datasets = [];

      if(this.select_todate){
        this.select_todate = false;
        this.$el.querySelector('#select_todate').disabled = true;
      }else{
        this.select_all = true;
        this.$el.querySelector('#select_todate').disabled = false;
      }
    },

    calcReportTotals(data){
      let totalCount = 0;
      let totalQuantity = 0;
      let totalReturn = 0;
      let totalPrice = 0;
      let totalTotal = 0;

      data.forEach(function(item) {

        totalCount = totalCount  + Math.round(parseFloat(item.count_item).toFixed(0)*100)/100;
        totalQuantity = totalQuantity + Math.round(parseFloat(item.total_qty).toFixed(3)*1000)/1000;
        totalReturn += Math.round(parseFloat(item.total_qty_return).toFixed(3)*1000)/1000;
        totalPrice += Math.round(parseFloat(item.total_price/item.total_qty).toFixed(2)*100)/100;                      
        totalTotal += Math.round(parseFloat(item.total_price)*100)/100;
      });
      this.totalCount_ = totalCount;
      this.totalQuantity_ = totalQuantity;
      this.totalReturn_ = totalReturn;
      this.totalPrice_ = totalPrice;
      this.totalTotal_ = totalTotal;

  },
      
  printReportChart(id){
    const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      //let reportFooter = "Printed on: "+year+"-"+month+"-"+day+ " "+time;
      let reportDate = this.dateToYMD(this.state.date);
      let reportDateTo = this.dateToYMD(this.stateTo.dateTo);
      let reportHeader = "";

      if(reportDate == reportDateTo){
        reportHeader = "Department Wise Report On "+this.dateToYMD(this.state.date);
      }else{
        reportHeader = "Department Wise Report Between "+this.dateToYMD(this.state.date)+ " AND "+this.dateToYMD(this.stateTo.dateTo);
      }
      let deptWiseReportDate = this.state.date;
      let reportData = this.itemsDaily;
      let totalCount= 0;
      let totalQuantity = 0;
      let totalReturn= 0;
      let totalPrice= 0;
      let totalTotal= 0;
                

      reportData.forEach(function(item) {

        totalCount = totalCount  + Math.round(parseFloat(item.count_item).toFixed(0)*100)/100;
        totalQuantity = totalQuantity + Math.round(parseFloat(item.total_qty).toFixed(3)*1000)/1000;
        totalReturn += Math.round(parseFloat(item.total_qty_return).toFixed(3)*1000)/1000;
        totalPrice += Math.round(parseFloat(item.total_price/item.total_qty).toFixed(2)*100)/100;                      
        totalTotal += Math.round(parseFloat(item.total_price)*100)/100;

      });
      this.printItemsDailyReport(reportData, reportDateTo, reportHeader, this.deptWiseReportDate , id, totalCount, totalQuantity, totalReturn, totalPrice, totalTotal)
  },
        printItemsDailyReport(reportData, reportDateTo, reportHeader, reportDate, id, totalCount, totalQuantity, totalReturn, totalPrice, totalTotal){
          var canvasEle = document.getElementById(id);
          let viaInvStr = '<div style="width:100%;text-align:center"><table width="100%" align="left" style="margin-right:0px; margin-left:0px">';
          viaInvStr = viaInvStr + '<tr><td>';
            viaInvStr = viaInvStr + '<table align="center" width="100%" style="border-bottom: #000000 0px solid; vertical-align:bottom"><tr><td width="100%" align="center"><img style="width:700px" src="'+canvasEle.toDataURL()+'" /></td></tr></table>'; 
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<tr><td>';
          //viaInvStr = viaInvStr + '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td width="100%" align="left" style="vertical-align:bottom"><b><p style="font-size:1.5em">'+reportHeader+'</p></b></td><td width="50%" align="left" ><b><p style="font-size:1.5em">Date:</p></b></td><td width="50%" align="left"><b><p style="font-size:1.5em">'+reportDate+ '</p></b></td></tr></table>'; 
          viaInvStr = viaInvStr + '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td width="100%" align="left" style="vertical-align:bottom"><b><p style="font-size:1.5em">'+reportHeader+'</p></b></td><td width="50%" align="left" ><b><p style="font-size:1.5em"></p></b></td><td width="50%" align="left"><b><p style="font-size:1.5em"></p></b></td></tr></table>'; 
          viaInvStr = viaInvStr + '</td></tr>';
          //viaInvStr = viaInvStr + '<tr><td>';
          //viaInvStr = viaInvStr + '<table align="left" width="25%"  style="border-bottom: #000000 2px solid;"><tr><td width="50%" align="left" ><b><p style="font-size:1.5em">Date:</p></b></td><td width="50%" align="left"><b><p style="font-size:1.5em">'+reportDate+ '</p></b></td></tr></table>';
          //viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';

          viaInvStr = viaInvStr + '<table align="center" width="90%" style="border-bottom: #000000 2px solid;"><tr>';
            viaInvStr = viaInvStr + '<td align="left"><b><p style="font-size:1.5em">Department Name</p></b></td>';
            viaInvStr = viaInvStr + '<td align="right"><b><p style="font-size:1.5em">Items Count</p></b></td>';
            viaInvStr = viaInvStr + '<td align="right"><b><p style="font-size:1.5em">Quantity</p></b></td>';
            viaInvStr = viaInvStr + '<td align="right"><b><p style="font-size:1.5em">Return</p></b></td>';
            viaInvStr = viaInvStr + '<td align="right"><b><p style="font-size:1.5em">Price</p></b></td>';
            viaInvStr = viaInvStr + '<td align="right"><b><p style="font-size:1.5em">Total</p></b></td></tr>';
          //viaInvStr = viaInvStr + '</td></tr>';
          //viaInvStr = viaInvStr + '<tr><td>';
          //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
          let self =this;
          reportData.forEach(function(item) {
            viaInvStr = viaInvStr + '<tr>';
              viaInvStr = viaInvStr + '<td align="left"><p style="font-size:1.5em">'+item.itemCode+'</p></td>';
              viaInvStr = viaInvStr + '<td align="right"><p style="font-size:1.5em">'+item.count_item+'</p></td>';
              viaInvStr = viaInvStr + '<td align="right"><p style="font-size:1.5em">'+parseFloat(item.total_qty).toFixed(3)+'</p></td>';
              viaInvStr = viaInvStr + '<td align="right"><p style="font-size:1.5em">'+parseFloat(item.total_qty_return).toFixed(3)+'</p></td>';
              viaInvStr = viaInvStr + '<td align="right"><p style="font-size:1.5em">'+self.formatNumber(item.total_price/item.total_qty)+'</p></td>';
              viaInvStr = viaInvStr + '<td align="right"><p style="font-size:1.5em">'+self.formatNumber(item.total_price)+'</p></td></tr>';
            //viaInvStr = viaInvStr + '</td></tr>';
            //viaInvStr = viaInvStr + '<tr><td>';
          });        
          viaInvStr = viaInvStr + '<tr style="border-top: #000000 2px solid; vertical-align:bottom">';
              viaInvStr = viaInvStr + '<td align="left" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">Totals</p></td>';
              viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">'+this.formatNumber(parseFloat(totalCount).toFixed(0))+'</p></td>';
              viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em"></p></td>';
              viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em"></p></td>';
              viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em"></p></td>';

              //viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">'+this.formatNumber(parseFloat(totalQuantity).toFixed(3))+'</p></td>';
              //viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">'+this.formatNumber(parseFloat(totalReturn).toFixed(3))+'</p></td>';
              //viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">'+this.formatNumber(parseFloat(totalPrice).toFixed(2))+'</p></td>';

              viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">'+this.formatNumber(parseFloat(totalTotal).toFixed(2))+'</p></td></tr>';
          viaInvStr = viaInvStr + '</table>';
          viaInvStr = viaInvStr + '</td></tr>';


          viaInvStr = viaInvStr + '</table></div>';
          this.sharedPrintElemmRep(viaInvStr);

      },

      parentfunctionSelectedhandler() {
    },
    datepickerOpenedFunction() {
    },
    parentfunctionCloseHandler() {
    },

      addOption (selectbox, value, text) {
          var optn = document.createElement("OPTION");
          optn.text = text;
          optn.value = value;
          selectbox.options.add(optn);  
      },      

  handleReports() {
      this.$router.push({ name: 'reports'} );
    },
  showChartHandling() {
    if(this.showChart){
      this.showChart = false;
    }else{
      this.showChart = true;      
    }
  },
    
  handleMainPage() {
      this.$router.push({ name: 'main'} );
    },

      
  getCurrentDateTime(){
    let dateTimeStr = '';
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      var today = new Date();
      //this.orderDate = year+'-'+month+'-'+day;
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      dateTimeStr = year+'-'+month+'-'+day+' '+time;
    return dateTimeStr;
  },
  handleFindItemsDaily(){
    this.findItemsDaily();
  },
  rebuildChart(){
    this.showChart = true;
                let data_ = [];
                let labels_ = [];
                
                if(this.itemsDaily.length>0){
                  this.itemsDaily.forEach(function(item) {
                      labels_.push(item.itemCode)

                      data_.push(item.total_price);

                  });
                  this.chartData.labels = labels_;
                  this.chartData.datasets = [];
                  this.chartData.datasets.push({"data":data_,
                  backgroundColor: ['yello', 'green', 'blue', 'red', 'cyan', 'navy', '#524178', '#aa3344'],
                  label: "Sales Amount With Category",           
                  fill: true,
                  borderColor: "rgb(43, 76, 153)",
                  tension: 0.1,
                  pointRadius: 0.1,
                  borderWidth: 2,
                  height: this.chartHeight, 
                  width: 200,
                });
              }

  },
   findItemsDaily: async function() {
  this.itemsDailyJson.appId = localStorage.appId;
  this.itemsDailyJson.orderDate = this.dateToYMD(this.state.date);
  this.itemsDailyJson.orderDateTo = this.dateToYMD(this.stateTo.dateTo);
  this.deptWiseReportDate = this.dateToYMD(this.state.date);
  this.itemsDailyJson.paid_by = this.paid_by;

  try {
    let dataURL = this.apiURL + 'GiftCard/findItemsAll';
    let response = await axios.post(dataURL, this.itemsDailyJson);

    if (response.data.status === 'success') {
      // 1. Store the raw daily data for the table
      this.itemsDaily = response.data.results.itemsDaily;
      this.calcReportTotals(this.itemsDaily);

      // 2. Process data for the chart: Aggregate by product code
      let chartDataMap = new Map(); // Use a Map to group items by itemCode

      this.itemsDaily.forEach(function(item) {
        // If the product isn't in the map, add it
        if (!chartDataMap.has(item.itemCode)) {
          chartDataMap.set(item.itemCode, {
            itemCode: item.itemCode,
            itemName: item.itemName, // Keep the name for the label
            total_price: 0,
            total_qty: 0
          });
        }
        // Get the existing product summary from the map
        let productSummary = chartDataMap.get(item.itemCode);
        // Add this day's values to the running totals
        productSummary.total_price += parseFloat(item.total_price);
        productSummary.total_qty += parseFloat(item.total_qty);
      });

      // 3. Convert the Map values to an array for the chart
      let aggregatedData = Array.from(chartDataMap.values());

      // 4. (Optional) Sort the data to show top sellers first, making the chart more useful.
      aggregatedData.sort((a, b) => b.total_price - a.total_price);

      // 5. Now build the chart with the AGGREGATED data
      this.showChart = true;
      let data_ = [];
      let labels_ = [];

      if (aggregatedData.length > 0) {
        // Only show top N items to avoid clutter (e.g., top 10 or 15)
        let itemsToShow = aggregatedData.slice(0, 15);

        itemsToShow.forEach(function(item) {
          // Use a shorter label for the X-axis
          labels_.push(item.itemCode); // or item.itemName if it fits, but codes are usually shorter
          data_.push(item.total_price);
        });

        this.chartData.labels = labels_;
        this.chartData.datasets = [{
          "data": data_,
          backgroundColor: [
            '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
            '#FF9F40', '#FF6384', '#C9CBCF', '#7CFC00', '#20B2AA',
            '#FFD700', '#FF6347', '#9370DB', '#00FA9A', '#1E90FF'
          ], // Better color array
          label: "Total Sales by Product", // Improved label
          fill: false,
          borderColor: "rgb(75, 85, 99)",
          tension: 0.1,
          pointRadius: 5, // Make points visible
          borderWidth: 2,
        }];
      }
    }
  } catch (error) {
    console.error("Error fetching items:", error);
    this.mainErrorMsg = "Failed to load report data.";
  }
},  


getUsers: async function(){
      this.usersJson.appId = localStorage.appId;
      let usersJson_ = JSON.stringify(this.usersJson);
      try{
          let dataURL = this.apiURL+'GiftCard/getPosUsers';
          let response = await axios.post(dataURL, usersJson_);  
          if(response.data.status === 'success'){
            ///console.log("response.data.status", response.data.status);
            //console.log("response.data.results", response.data.results);
            //this.users = this.json2array(response.data.results);

            this.users = response.data.results;
            //console.log("this.users", this.users)
            var dropdown = document.getElementById("paid_by");
            if (dropdown) {
                for (var i=0; i < this.users.length;++i){    
                    this.addOption(dropdown, this.users[i].id, this.users[i].partOne);
                }
            }


          }
      }
      catch (error){
          console.log(error);
      }
    },   

    getCustomerAddresses: async function(customerid){
      //let customersJson = {};      
      this.customersJson.appId = localStorage.appId;
      //this.customersJson.appId = "7";           
      this.customersJson.customerid = customerid;
      let customersJson_ = JSON.stringify(this.customersJson);
      try{
          
          let dataURL = this.apiURL+'Customers/getCustomerAddresses';

          let response = await axios.post(dataURL, customersJson_);  
          if(response.data.status === 'success'){
            this.customerAddresses = response.data.results.customersAddresses;
          this.addressid = this.customerAddresses[0].id;
          this.addressLine1 = this.customerAddresses[0].line;
          this.addressLine2 = this.customerAddresses[0].line1;
          this.addressArea = this.customerAddresses[0].area;
          this.addressCity = this.customerAddresses[0].city;
          this.isDefault = this.customerAddresses[0].is_default;

            this.showAddress = true;
          }else{
            this.showAddress = true;
            this.customerAddresses = [];
          }
      }
      catch (error){
          console.log(error);
      }
    },   

   goLogin()
    {
      this.$router.push({ name: 'login', query: { redirect: '/login' } });
    },

  fixNumber(num)
    {
      let mum2 = parseFloat(Math.round(num)).toFixed(2);
      return mum2;
    },
    getImgUrl(){
      let logoUrlStr;
      logoUrlStr = this.logoUrl;
      return logoUrlStr;
    },
    getLogo: async function(){
        try{            
            let dataURL = this.apiURL+'Orders/getInvoiceLogo';
            let logoJson = {"appId": localStorage.appId};
            let response = await axios.post(dataURL, logoJson); 
            if(response.data.status === 'success'){
                this.logoUrl=response.data.results.logourl;
            }
        }
        catch (error){
            console.log(error);
        }
      },    
    }
  }
</script>
<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
  /*overflow-y: hidden;*/
}

.glyphicon.glyphicon-ok {
    font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #EEEEEE;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #CCCCCC;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #CCCCCC; */
}
.grid-container-element { 
    display: grid; 
    grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr; 
    grid-gap: 10px; 
    border: 1px solid whitesmoke; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    width: 100%; 
} 
.grid-child-element_ { 
    margin: 10px; 
    border: 1px solid red; 
}
.grid-child-element { 
    margin: 2px; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    padding : 0 px;
    
}

</style>